import { Component, EventEmitter, OnInit, Output, TemplateRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

import { MatDialog } from '@angular/material/dialog';
import { ContentServiceService } from '../../../content-service.service';
import { FilterModel, Metadata } from 'src/app/common/MasterModel/masterModel';

import { DialogService } from 'src/app/common/core-services/DialogService';
import { PartnersModel } from './PartnersModel';

@Component({
  selector: 'app-view-partner',
  templateUrl: './view-partner.component.html',
  styleUrls: ['./view-partner.component.css']
})
export class ViewPartnerComponent implements OnInit {

  requestpages: any;
  form: FormGroup;
  metaData: any;
  private filterModel: FilterModel;
  partnersData: PartnersModel[];
  @Output() handleTabChange: EventEmitter<any> = new EventEmitter<any>();
  classToggled = false;

  public toggleField() {
   this.classToggled = !this.classToggled;
  }

  displayedColumns: Array<any> = [
    { displayName: 'PARTNER NAME', key: 'partnesName', isSort: true, class: '', width: '80%' },
    { displayName: 'Actions', key: 'Actions', class: '', width: '10%' }

  ];
   actionButtons: Array<any> = [
    //{ displayName: 'Details', key: 'Details', class: 'fas fa-eye' },
    { displayName: 'Edit', key: 'edit', class: 'fas fa-edit' },
    { displayName: 'Delete', key: 'delete', class: 'fas fa-trash' },
  ];
  constructor(private dialog: MatDialog,
    private formBuilder: FormBuilder,
    private router: Router,
    private toaster: ToastrService,
    private dialogService: DialogService,
    private contentService: ContentServiceService,
    ) { 

     this.filterModel = new FilterModel();
     this.partnersData = new Array<PartnersModel>();
    }

  ngOnInit(): void {
    this.metaData = new Metadata();
    this.form = this.formBuilder.group({
      searchValue: [''],
     
    });

    this.getpartnerList(this.filterModel, '', '', );
  }
  onPageOrSortChange(changeState?: any) {
    this.setPaginatorModel(changeState.pageNumber, this.filterModel.pageSize, changeState.sort, changeState.order, this.filterModel.searchText);
    this.getpartnerList(this.filterModel, '', '')
  }
  setPaginatorModel(pageNumber: number, pageSize: number, sortColumn: string, sortOrder: string, searchText: string) {
    this.filterModel.pageNumber = pageNumber;
    this.filterModel.pageSize = pageSize;
    this.filterModel.sortOrder = sortOrder;
    this.filterModel.sortColumn = sortColumn;
    this.filterModel.columnName = sortColumn;
    this.filterModel.searchText = searchText;
  }

  getpartnerList(filterModel: any, tags: any, roleIds: any) {
    this.contentService.getPartnerdata(filterModel).subscribe((res: any) => {
      if(res.status > 0){
        console.log(res);
        this.partnersData = res.responseData;
        this.metaData = res.meta;
       
      }else{
        this.metaData = new Metadata();
      }
     
    });
  }

  onTableActionClick(actionObj?: any) {
    const id = actionObj.data && actionObj.data.partnesID;
    switch ((actionObj.action || '').toUpperCase()) {
      case 'EDIT':
        //this.editCall(id);
        this.handleTabChange.next({ tab: "Add Partner", id: id});
        break;
      case 'DELETE':
        {
          
          this.dialogService
            .confirm(`Are you sure you want to delete this record?`)
            .subscribe((result: any) => {
              if (result == true) {
                this.deletePartner(id);
              }
            });
        }
        break;
        case 'DETAILS':
        //this.infoCall(id);
        break;
      default:
        break;
    }
  }
  applyFilter(searchText: string = '') {
    this.setPaginatorModel(1, this.filterModel.pageSize, this.filterModel.sortColumn, this.filterModel.sortOrder, searchText);
    if (searchText.trim() == '' || searchText.trim().length >= 3) {
      this.getpartnerList(this.filterModel, '', '');
    }
  }

  // searching
  onSubmit() {
    this.requestpages = {
      "pageSize": 10,
      "pageNumber": 1,
      "searchValue": this.form.controls.searchValue.value,
      "columnName": "",
      "sortOrder": ""
    }
    console.log(this.requestpages);
    this.getpartnerList(this.requestpages, '', '')
    //this.AdminUserList();
  }
  reset() {
    this.form.reset();
    this.InitialGridCall();
   
    this.getpartnerList(this.requestpages, '', '')
  }

  InitialGridCall() {
    this.requestpages = {
      "pageSize": 10,
      "pageNumber": 1,
      "searchValue": "",
      "columnName": "",
      "sortOrder": ""
    }
  }
  // end

  deletePartner(id:any){
    this.contentService.DeletePartner(id).subscribe((res: any) => {
      if(res.status > 0){
        console.log(res);
        this.toaster.success(res.message, 'Success');
        //this.reset();
        this.getpartnerList(this.filterModel, '', '', );
       
      }else{
        this.metaData = new Metadata();
      }
     
    });
  }
  goto(){
    this.handleTabChange.emit({ tab: "Add Partner", id: 0});
  }

}
